import { Typography, Box, Grid, Button } from '@mui/material';
import Hero from 'components/Hero';
import img from 'assets/images/number-one.png';
import React from 'react';
import ServiceSection from 'components/services';

function Home() {
  return (
    <div style={{ marginBottom: 63 }}>
      <div style={{marginTop:34 }}>
        <Hero />
        <div className="container">
          <div
            style={{
              margin: '88px 0px',
              display: 'flex',
              flexDirection: 'column',
              gap: 16,
            }}>
            <Grid container spacing={3} alignItems={'center'}>
              <Grid item xs={12} md={7}>
                <Box sx={{ width: '70%' }}>
                  <Typography variant="h4"  color={'text.primary'} fontWeight={600}> درباره ما</Typography>
                  <Typography
                    variant="body1"
                    color={'text.secondary'}
                    sx={{ mt: 2 }}>
                    On the other hand, we denounce with righteous indignation
                    and dislike men who are so beguiled and demoralized by the
                    charms of pleasure of the moment, so blinded by desire, that
                    they cannot foresee the pain and trouble that are bound to
                    ensue; and equal blame belongs to those who fail in their
                    duty through weakness of will, which is the same as saying
                    through shrinking from toil and pain.
                  </Typography>
                </Box>
                <Button variant="contained" sx={{ mt: 2 }}>
                  Detail
                </Button>
              </Grid>
              <Grid item xs={12} md={5}>
                <Box sx={{ overflow: 'hidden' }}>
                  <img src={img} width={'100%'} style={{ objectFit: 'none' }} />
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <ServiceSection />
    </div>
  );
}

export default Home;
